import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { Button, InlineNotification, PasswordInput } from '@carbon/react';
import { api } from '../api/client';
import { useAuth } from '../auth/AuthContext';
import { PageHeader, InlineError } from '../components/states';

export function MyAccountPage() {
  const { me, logout } = useAuth();
  const [f, setF] = useState({ current: '', next: '', again: '' });
  const m = useMutation({
    mutationFn: () => api.post('/api/admin/me/password', { current: f.current, next: f.next }),
    onSuccess: () => setTimeout(() => logout(), 1500),
  });
  const mismatch = f.again.length > 0 && f.again !== f.next;
  return (
    <div className="page">
      <PageHeader title="Tài khoản của tôi" lead={`${me?.displayName} (${me?.username}), vai trò ${me?.roleLabel}.`} />
      <section className="stack" style={{ maxWidth: 420 }}>
        <h2>Đổi mật khẩu</h2>
        <PasswordInput showPasswordLabel="Hiện mật khẩu" hidePasswordLabel="Ẩn mật khẩu" id="c" labelText="Mật khẩu hiện tại" autoComplete="current-password" value={f.current} onChange={(e) => setF({ ...f, current: e.target.value })} />
        <PasswordInput showPasswordLabel="Hiện mật khẩu" hidePasswordLabel="Ẩn mật khẩu" id="n" labelText="Mật khẩu mới" helperText="Tối thiểu 12 ký tự" autoComplete="new-password" value={f.next} onChange={(e) => setF({ ...f, next: e.target.value })} />
        <PasswordInput showPasswordLabel="Hiện mật khẩu" hidePasswordLabel="Ẩn mật khẩu" id="a" labelText="Nhập lại mật khẩu mới" autoComplete="new-password" invalid={mismatch} invalidText="Hai lần nhập không khớp" value={f.again} onChange={(e) => setF({ ...f, again: e.target.value })} />
        <InlineError error={m.error} />
        {m.isSuccess ? <InlineNotification kind="success" lowContrast hideCloseButton title="Đã đổi mật khẩu" subtitle="Mọi phiên đăng nhập đã bị thu hồi. Đăng nhập lại bằng mật khẩu mới." /> : null}
        <Button disabled={m.isPending || f.next.length < 12 || mismatch || !f.current} onClick={() => m.mutate()}>Đổi mật khẩu</Button>
      </section>
    </div>
  );
}
